import React, { Fragment, useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { ReportsTab } from '../components'
import { TextField, Grid, Paper, Button, Table, TableHead, TableBody, TableRow, TableCell, Tooltip, Chip } from '@material-ui/core';
import { customAlrtFilterOps } from '..';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { FilterComponent } from '../../../shared_elements';
import { checkApiStatus, getLocalStorageInfo, checkPermission } from '../../../utils';
import { DeletePopUp, EmptyCollection, PageLoader, Pagination } from '../../../shared_elements';
import moment from 'moment';
import { Delete, Edit } from '@material-ui/icons';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddEditAlerts from '../components/AddEditAlerts';
import FilterListIcon from "@material-ui/icons/FilterList"
import AddIcon from "@material-ui/icons/Add"
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import TimelineIcon from '@material-ui/icons/Timeline';
import { getAllAssetListAc } from '../../../shared_elements/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import RevisionList from '../components/RevisionList';
import { displayDateFormat } from '../../../constants';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { STableLoader } from '../../../shared_elements/loaders';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
export default function CustomAlerts() {
    const [filter, setFilter] = useState({});
    const [alertsList, setAlertsList] = useState([]);
    const [alertModal, setAlertModal] = useState({ flag: false });
    const [deleteAlert, setDeleteAlert] = useState({});
    const [pageloader, setPageloader] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [revisionList, setRevisionList] = useState({ flag: false });
    const [activityTypeList, setActivityType] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const allAssets = useSelector(state => state?.shareReducer?.allAssets || [])
    const [alertFrequencyList, setAlertFrequencyList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllAssetListAc())
        getCustomAlertsList()
        getActivityTypeApi()
        getUsersListFn()
    }, [])
    const getCustomAlertsList = (query, loaderType) => {
        if (loaderType === 'pageLoader') {
            setPageloader(true)
        }
        else setSkeletonLoader(true)
        globalGetService(`records/reports/custom-alerts/`, query)
            .then(response => {
                if (loaderType === 'pageLoader') {
                    setPageloader(false)
                } else {
                    setSkeletonLoader(false)
                }
                setAlertsList(response.data.data)
                if (query) {
                    delete query?.per_page
                    delete query?.page
                    delete query?.total
                    setFilter(query)
                }
            })
    }

    function getActivityTypeApi(props) {
        globalGetService(`records/v2/get-activity-list/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setActivityType(response.data.data)
                }
            })
    }
    const setEditAlerts = (item, mode) => {
        setAlertModal({ flag: true, data: item, mode: mode })
    }
    const setRevionAlert = (item, query) => {
        setPageloader(true)
        globalGetService(`records/reports/custom-alerts/${item?.id}/history/`, query)
            .then(response => {
                setPageloader(false)
                if (checkApiStatus(response)) {
                    setRevisionList({ flag: true, data: response?.data.data, item: item })
                }
            })
    }
    const getUsersListFn = () => {
        globalGetService('records/userslist/', { application: 6 })
            .then(response => {
                if (checkApiStatus(response)) {
                    // let responseData = response.data?.data?.map(item => {return(
                    //    { ...item, label:`${item?.name || ''} (${item?.email})`}
                    // )})
                    setUsersList(response.data.data)
                }
            })
    }
    const deleteAlertFn = (id) => {
        setPageloader(true)
        globalDeleteService(`/records/reports/custom-alerts/${id}`)
            .then(response => {
                setPageloader(false)
                if (checkApiStatus(response)) {
                    setDeleteAlert({ flag: false })
                    getCustomAlertsList()
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                }
            })
    }
    let filterOptions = Object.assign({}, customAlrtFilterOps)
    filterOptions = {
        ...filterOptions,
        activity_type: {
            ...filterOptions.activity_type,
            options: activityTypeList.filter(item => ![34, 35, 36, 37, 38].includes(item?.value))

        },
        assets: {
            ...filterOptions.assets,
            options: allAssets
        }
    }
    return (
        <section className="action-docks fleets-management">
            <DeploymentMessage />
            <ReportsTab
                tabIndex="customalerts"
            />
            {skeletonLoader ? <STableLoader count={9} size={8} /> :
                <Paper>
                    <Grid container spacing={1}>
                        <Grid item sm={9}>
                            <FilterComponent
                                icon={<FilterListIcon style={{ margin: '5px 0px 5px 10px' }} />}
                                filter={filter}
                                filterMenu={filterOptions}
                                getResponseBack={(applyFilter) => { getCustomAlertsList({ ...applyFilter, page: 1, per_page: alertsList?.pagination?.per_page }, 'pageLoader'); }}
                            />
                        </Grid>
                        {checkPermission('reports', 'custom_alert', 'C') ? <Grid item sm={3}>
                            <div style={{ textAlign: 'right', paddingTop: '2px', paddingRight: '5px' }}>
                                <Button style={{ cursor: "pointer", marginBottom: '8px', position: 'relative' }} onClick={() => setAlertModal({ flag: true, data: { alert_frequency_type: 0 } })} color="primary" size="small" variant="contained">
                                    <AddIcon style={{ fontSize: '1.15rem', }} /> Add Custom Alerts
                                </Button>
                            </div>
                        </Grid> : null}
                    </Grid>
                    <div style={{ overflow: "scroll", height:`${window.innerHeight-230}px` }} >
                        <Table className='mui-table-format' stickyHeader>
                            <TableHead>
                                <TableCell>Activity Type</TableCell>
                                <TableCell>Notification Preference</TableCell>
                                <TableCell>Alert Valid Till</TableCell>
                                <TableCell>Assets</TableCell>
                                <TableCell >Users</TableCell>
                                <TableCell>Created By</TableCell>
                                <TableCell align='right' style={{ zIndex: '1' }}>Action</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    alertsList?.list?.length > 0 && alertsList?.list?.map((item, index) =>
                                        <CustomList
                                            setDeleteAlert={(id) => setDeleteAlert({ flag: true, id: id })}
                                            item={item}
                                            setEditAlerts={setEditAlerts}
                                            setRevionAlert={setRevionAlert}
                                        />
                                    )
                                }
                            </TableBody>
                        </Table>
                        {
                            alertsList?.list < 1 && !pageloader ?
                                <EmptyCollection title={'No records found'} /> : null
                        }
                    </div>
                    <Pagination
                        pagination={alertsList.pagination}
                        onChangePage={(event, newPage) => getCustomAlertsList({ page: newPage + 1, per_page: alertsList.pagination.per_page }, 'pageLoader')}
                        onChangeRowsPerPage={(event) => getCustomAlertsList({ page: 1, per_page: event.target.value }, 'pageLoader')}
                    />
                </Paper>}
            {
                alertModal.flag ?
                    <AddEditAlerts
                        getResponseBack={() => { getCustomAlertsList({ ...filter, ...alertsList.pagination }); setAlertModal({ flag: false }) }}
                        allAssets={allAssets}
                        activityTypeList={activityTypeList}
                        usersList={usersList}
                        alertModal={alertModal}
                        toggleModalFn={() => setAlertModal({ flag: false })}
                        alertFrequencyList={alertFrequencyList}
                    />
                    : null
            }
            {deleteAlert.flag ?
                <DeletePopUp
                    modal={deleteAlert.flag}
                    toggleModalFn={() => setDeleteAlert({ flag: false, data: null })}
                    title="Delete Custom Alert"
                    content={<h4>Are you sure you want to delete?</h4>}
                    triggerEventFn={() => deleteAlertFn(deleteAlert?.id)}
                /> : null
            }{
                revisionList?.flag ?
                    <RevisionList
                        getResponseBack={setRevionAlert}
                        revisionList={revisionList}
                        toggleModalFn={() => setRevisionList({ flag: false })}
                    /> : null
            }
            {
                pageloader ? <PageLoader /> : null
            }
        </section>
    )
}
const CustomList = ({ item, setEditAlerts, setDeleteAlert, setRevionAlert }) => {
    const getOrdinal = (number) => {
        if (10 <= number % 100 && number % 100 <= 20) {
            return 'th';
        } else {
            const suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[number % 10] || 'th';
            return suffix;
        }
    };
    return (
        <TableRow>
            <TableCell>
                {item.activity_type?.label || '--'}
            </TableCell>
            <TableCell>
                {item.alert_frequency_type?.label || '--'}

                {item.alert_frequency_type?.value == 2 ?
                    <p style={{ fontSize: "13px" }}>On {item.notify_every_week_on?.label || '--'} at 1:30AM UTC</p>
                    : null
                }
                {item.alert_frequency_type?.value == 3 ?
                    <p style={{ fontSize: "13px" }}> {item.notify_every_month_on?.value}{getOrdinal(item.notify_every_month_on?.value)} of every month at 1:30AM UTC</p>
                    : null
                }
                {item.alert_frequency_type?.value == 0 ?
                    <p style={{ fontSize: "13px" }}>At 1:30AM UTC</p>
                    : null
                }


            </TableCell>
            <TableCell>
                {item.valid_till ? moment(item.valid_till).format('MMM DD, YYYY') : '--'}
                <p style={{ fontSize: "11px" }}>
                    {item.valid_till ?
                        moment(item.valid_till).diff(moment().format(displayDateFormat)) < 0 ?
                            <Chip size='small' label='Expired' style={{ background: '#d91717', color: '#fff' }} />
                            :
                            <Chip size='small' label='Active' style={{ background: '#008000', color: '#fff' }} />

                        : null
                    }
                </p>

            </TableCell>
            <TableCell onClick={() => setEditAlerts(item, 'view')} style={{ maxWidth: "240px" }}>
                <Tooltip arrow title={item.asset_names} placement="top">
                    <span>
                        {item.asset_names.length < 30 ?
                            item.asset_names || 'All'
                            :
                            <span>
                                {item.asset_names.slice(0, 30)} <span style={{ color: '#058ad5', cursor: 'pointer' }}>...more</span>
                            </span>
                        }
                    </span>
                </Tooltip>

            </TableCell>
            <TableCell onClick={() => setEditAlerts(item, 'view')} style={{ maxWidth: "240px" }}>
                <Tooltip arrow title={item.user_names} placement="top">
                    <span>
                        {item.user_names.length < 30 ?
                            item.user_names
                            :
                            <span>
                                {item.user_names.slice(0, 30)} <span style={{ color: '#058ad5', cursor: 'pointer' }}>...more</span>
                            </span>
                        }
                    </span>
                </Tooltip>
            </TableCell>

            <TableCell>
                {item.created_by_display?.name || '--'}
                <p style={{ fontSize: "13px" }}>
                    {item.created_at ? moment(item.created_at).format('MMM DD, YYYY hh:mmA') : '--'}
                </p>
            </TableCell>
            <TableCell align='right'>
                <Tooltip arrow title='View details' placement="top">
                    <VisibilityIcon style={{ cursor: "pointer" }} color='primary' fontSize='small'
                        onClick={() => setEditAlerts(item, 'view')}
                    />
                </Tooltip>
                {checkPermission('reports', 'custom_alert', 'U') ? <Tooltip arrow title='Edit' placement="top">
                    <Edit style={{ cursor: "pointer" }} color='primary' fontSize='small' onClick={() => setEditAlerts(item)} />
                </Tooltip> : null}
                {checkPermission('reports', 'custom_alert', 'D') ? <Tooltip arrow title='Delete'  placement="top">
                    <Delete style={{ cursor: "pointer" }} color='secondary' fontSize='small' variant='outlined' onClick={() => setDeleteAlert(item?.id)} />
                </Tooltip> : null}
                <Tooltip arrow title='Emails Sent History' placement="top">
                    <TimelineIcon style={{ cursor: "pointer" }} color='primary' fontSize='small' onClick={() => setRevionAlert(item)} />
                </Tooltip>
                <RevisionHistory
                    url={`audit/records/customalert/`}
                    queryParams={{ action: 1, object_id: item.id }}
                    buttonType={true}
                    component={true}
                    exportRevisionHistory={true}
                    exportQueryparam={{ action: 1, object_id: item.id, download: 'xls' }}
                    moduleType={"Custom Alerts"}
                    exportPermission={getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission['reports'] && getLocalStorageInfo().user.permission['reports']['custom_alert'] && getLocalStorageInfo().user.permission['reports']['custom_alert'].indexOf('R') != -1}
                />
            </TableCell>
        </TableRow>
    )
}